/**
 * Utility functions for HTTP interceptors
 */

/**
 * List of external API URLs that should bypass Maptycs backend interceptors
 */
const EXTERNAL_API_URLS = [
    'https://api.aerisapi.com/',
    // Add other external APIs here if needed in the future
];

/**
 * Checks if the given URL is an external API that should bypass interceptors
 * @param url - The request URL to check
 * @returns true if the URL is an external API, false otherwise
 */
export function isExternalApi(url: string): boolean {
    return EXTERNAL_API_URLS.some(apiUrl => url.startsWith(apiUrl));
}

/**
 * Checks if the given URL is an Aeris API call
 * @param url - The request URL to check
 * @returns true if the URL is an Aeris API call, false otherwise
 */
export function isAerisApi(url: string): boolean {
    return url.startsWith('https://api.aerisapi.com/');
}